module.exports = __webpack_public_path__ + "img/组 2.8d3d12d1.png";